import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isNotEmptyHTML = ({ fieldValue }) => ({
  error: i18n.t('error-required-field-error'),
  hasError:
    !fieldValue ||
    !new DOMParser().parseFromString(fieldValue, 'text/html').body.textContent.trim().length,
  isRequired: true,
});

registerValidator('isNotEmptyHTML', isNotEmptyHTML);

export default isNotEmptyHTML;
